"use client"

import { motion } from "framer-motion"
import {
  Users,
  PenToolIcon as Tool,
  Calendar,
  Wallet,
  Bell,
  Smartphone,
  type LucideIcon,
} from "lucide-react"

interface FeatureCardProps {
  title: string
  description: string
  icon: string
  delay?: number
}

export default function FeatureCard({ title, description, icon, delay = 0 }: FeatureCardProps) {
  const iconMap: Record<string, LucideIcon> = {
    users: Users,
    tool: Tool,
    calendar: Calendar,
    wallet: Wallet,
    bell: Bell,
    smartphone: Smartphone,
  }

  const IconComponent = iconMap[icon] || Users

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
      className="group rounded-2xl border border-white/5 bg-white/[0.02] p-6 backdrop-blur-sm transition-all hover:border-teal-500/20 hover:bg-white/[0.04]"
    >
      <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-teal-500/20 to-emerald-500/20">
        <IconComponent className="h-5 w-5 text-teal-400" />
      </div>
      <h3 className="mb-2 text-lg font-semibold text-white">{title}</h3>
      <p className="text-sm leading-relaxed text-gray-400">{description}</p>
    </motion.div>
  )
}
